import {
  FACET_PAGE,
  FACET_PRICE,
  FACET_QUERY,
  FACET_SORT,
} from './ActiveFilters.constants'
import type { Facets, Filters, RemoveableFilter } from './ActiveFilters.types'

export function computeRemovableFilters(filters: Filters, facets: Facets) {
  return (
    Object.keys(filters)
      // Let's remove page, sort, search query and price facets as we don't do anything with those
      .filter(
        (filter) =>
          ![FACET_PAGE, FACET_SORT, FACET_QUERY, FACET_PRICE].includes(filter),
      )
      // Let's format the data to get an array of { facet, value, label }
      .reduce<RemoveableFilter[]>((values, facet) => {
        const facetFilters = filters[facet]

        if (!Array.isArray(facetFilters)) {
          return values
        }

        const filteredFacetFilters = facetFilters
          .map((filterValue) => {
            const label =
              facets
                .find(({ facetName }) => facet === facetName)
                ?.facetValues.find(
                  // eslint-disable-next-line camelcase
                  ({ facet_value }) => facet_value === filterValue,
                )?.label ?? undefined

            // If the value is not found (for instance, by adding a random one in the hash like
            // &brand=doesnotexist), we ignore it.
            if (!label) {
              return undefined
            }

            return {
              facet,
              value: filterValue,
              label,
            }
          })
          .filter((value): value is RemoveableFilter => !!value)

        return [...values, ...filteredFacetFilters]
      }, [])
  )
}
